import React from 'react'

export function TrendAnalysisIcon() {
    return (
        <>
            <i style={{ marginRight: "14px" }} className="icofont icofont-chart-histogram"></i>
        </>
    )
}


export function DataAdd() {
    return (
        <>
            <i style={{ marginRight: "14px" }} className="icofont icofont-database-add"></i>
        </>
    )
}
export function DownTimeRCAIcon() {
    return (
        <>
            <i style={{ marginRight: "14px" }} className="icofont icofont-broken"></i>
        </>
    )
}

export function Cogs() {
    return (
        <>
            <i style={{ marginRight: "14px" }} className="fa fa-cogs"></i>
        </>
    )
}
export function Warehouse() {
    return (
        <>
            <i style={{ marginRight: "14px" }} className="fa-solid fa-warehouse"></i>
        </>
    )
}
export function Desktop() {
    return (
        <>
            <i style={{ marginRight: "14px" }} className="fa fa-desktop"></i>
        </>
    )
}